export const parseDate = (date?: string | Date) => {
  if (date) {
    return new Date(
      `${typeof date === 'string' ? date.length > 10 ? date : `${date}T00:00:00.000Z` : date.toISOString()}Z`
        .replace(' ', 'T')
        .replace('ZZ', 'Z')
    );
  }
  return new Date();
}